// File: src/components/social/ShareButton/ShareButton.tsx
// Purpose: Social interaction component (comments, likes, shares)

import React from "react";
import styled from "styled-components";
import { Share2 } from "lucide-react";

interface ShareButtonProps {
  onClick: () => void;
}

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: ${({ theme }) => theme.spacing.sm};
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-weight: ${({ theme }) => theme.fonts.fontWeightMedium};
  transition: ${({ theme }) => theme.transitions.default};

  &:hover {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;

export const ShareButton: React.FC<ShareButtonProps> = ({ onClick }) => {
  return (
    <Button onClick={onClick} aria-label="Share button">
      <Share2 size={20} />
      Share
    </Button>
  );
};